import Header from "@/components/header";
import { Button, Card, Group, Radio, Stack, Text } from "@mantine/core";
import ListItemLoading from "@/components/loading/listItemLoading/listItemLoading";
import CustomStepper from "@/components/stepper";
import { useGetMerchantServices } from "@/services/appointment/hooks/useGetMerchantServices";
import useScheduleStore from "@/store/schedule";
import { notifications } from "@mantine/notifications";
import { IconChevronLeft, IconCircleFilled } from "@tabler/icons-react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { stepperAppointment } from "../type";

function SelectService() {
  const { data, isLoading } = useGetMerchantServices();
  const navigate = useNavigate();
  const { setMerchantService } = useScheduleStore();
  const [value, setValue] = useState("");
  const { state } = useLocation();

  const submit = () => {
    if (!value) {
      notifications.show({
        message: "لطفا سرویس را انتخاب نمایید را انتخاب نمایید",
        color: "yellow",
      });
      return;
    }
    setMerchantService({
      selectService: data?.find((item) => item?.id === Number(value)) || {},
    });

    navigate("/dashboard/schedule/selectTime", {
      state,
    });
  };

  return (
    <>
      <Stack h="100svh">
        <Header showBack showHome title="افزودن نوبت" />
        <CustomStepper steppers={stepperAppointment} active={1} />
        <Stack
          h={"calc(100svh - 200px)"}
          styles={{
            root: {
              flexGrow: 1,
              overflow: "hidden",
              overflowY: "auto",
            },
          }}
          px="lg"
        >
          {isLoading ? (
            <ListItemLoading count={3} />
          ) : (
            <Radio.Group value={value} onChange={setValue}>
              <Stack gap="xs">
                {data?.map((item) => (
                  <Card
                    withBorder
                    key={item?.id}
                    bg={item?.id?.toString() === value ? "blue.1" : ""}
                  >
                    <Radio
                      key={item?.id}
                      styles={{
                        labelWrapper: {
                          width: "100%",
                        },
                      }}
                      value={item?.id?.toString()}
                      label={
                        <Group justify="space-between">
                          <Group gap="xs">
                            <IconCircleFilled
                              // color={item?.color || ""}
                              size={10}
                            />
                            <Text size="xs">{item?.title}</Text>
                          </Group>
                          <Text size="xs" c="dimmed">
                            {/* هر {item?.durationPartInMinute} دقیقه */}
                            هر فیکس دقیقه
                          </Text>
                        </Group>
                      }
                    />
                  </Card>
                ))}
              </Stack>
            </Radio.Group>
          )}
        </Stack>
        <Stack px="lg">
          <Button
            type="submit"
            size="md"
            my="md"
            fullWidth
            form="add-customer"
            onClick={submit}
          >
            <Group>
              <Text>مرحله بعد</Text>
              <IconChevronLeft size={20} />
            </Group>
          </Button>
        </Stack>
      </Stack>
    </>
  );
}

export default SelectService;
